// Just added these two because it's what We currently need, more to be added
const getSwapAmountByPlanCode = (planCode: string): string => {
  const plansPrice = {
    fffvipa: '49.99',
    fffvip: '54.99',
  };
  return plansPrice[planCode as keyof typeof plansPrice];
};

export { getSwapAmountByPlanCode };
